// Action types constants
export const paymentMethodActionTypes = {
  UPDATE_PAYMENT_METHOD: 'UPDATE_PAYMENT_METHOD',
};

export const updatePaymentMethod = payload => ({
  type: paymentMethodActionTypes.UPDATE_PAYMENT_METHOD,
  payload,
});
